import { createAction, createReducer } from 'redux-starter-kit'

export const FETCH_PRODUCT_UPDATES_LINK = '[product updates] fetch link'
export const SET_PRODUCT_UPDATES_LINK = '[product updates] set link'

export const fetchProductUpdatesLinkAction = createAction(
  FETCH_PRODUCT_UPDATES_LINK
)
export const setProductUpdatesLinkAction = createAction(
  SET_PRODUCT_UPDATES_LINK
)

const initialState = {
  url: null,
  notifiedAt: null,
}

export default createReducer(initialState, {
  [SET_PRODUCT_UPDATES_LINK]: (state, { payload }) => {
    state.url = payload?.url || null
    state.notifiedAt = payload?.notifiedAt || null
  },
})

export const getProductUpdatesUrlSelector = (state) => state.productUpdates?.url

export const getProductUpdatesNotifiedAtSelector = (state) =>
  state.productUpdates?.notifiedAt || null
